<template>
  <div class="page flex-col">
    <div class="block_1 flex-col justify-end">
      <!-- <div class="block_2 flex-row">
        <img
          class="image_1"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng5eb7835fc957042f4b02048930b15033b02aadc08574d830df2c060761b9879a.png"
        />
        <img
          class="image_2"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng4b858c76b9deb5b3941827f27d1c8ac1b586ba98eec1392060201b04c690af4c.png"
        />
        <span class="text_1">自由随心·Al随行·慧安智远</span>
       <span class="text_2" @click="PageIndex">首页</span>
       <span class="text_3" @click="sdycxq">产品方案</span>
        <span class="text_4" @click="case_presentation">案例展示</span>
        <span class="text_5" @click="news_information">新闻动态</span>
        <span class="text_6" @click="guanyuhuian">关于慧安</span>
      </div> -->
       <div class="block_2 flex-row items-center"> <!-- 新增items-center确保垂直居中 -->
        <img class="image_1" referrerpolicy="no-referrer"
          src="./assets/img/SketchPng5eb7835fc957042f4b02048930b15033b02aadc08574d830df2c060761b9879a.png" />
        <img class="image_2" referrerpolicy="no-referrer"
          src="./assets/img/SketchPng4b858c76b9deb5b3941827f27d1c8ac1b586ba98eec1392060201b04c690af4c.png" />
        <span class="text_1">自由随心·Al随行·慧安智远</span>
        <span class="text_2" @click="PageIndex">首页</span>
        <!-- <span class="text_3" @click="sdycxq">产品方案</span> -->

        <div class="dropdown-container" @mouseenter="showDropdown = true" @mouseleave="showDropdown = false">
          <span class="text_3 cursor-pointer">产品方案</span>
          <div class="dropdown-menu" v-if="showDropdown">
            <div class="dropdown-item" @click="handleCaseClick('three_narcotic_drug_vehicle')">三代麻精药品车</div>
            <div class="dropdown-item" @click="handleCaseClick('two_narcotic_drug_vehicle')">二代麻精药品车</div>
            <div class="dropdown-item" @click="handleCaseClick('consumables_cabinet')">高值耗材柜</div>
            <div class="dropdown-item" @click="handleCaseClick('ai_recycling_bin')">AI智能回收箱</div>
            <div class="dropdown-item" @click="handleCaseClick('hydrogenperoxide_disinfection_machine')">过氧化氢消毒机</div>
            <div class="dropdown-item" @click="handleCaseClick('transfer_bed')">电动转运床</div>

          </div>
        </div>

        <span class="text_4" @click="case_presentation">案例展示</span>
        <span class="text_5" @click="news_information">新闻动态</span>
        <span class="text_6" @click="guanyuhuian">关于慧安</span>
      </div>

      <div class="block_3 flex-row"><div class="group_1 flex-col"></div></div>
    </div>
    <div class="block_4 flex-col"></div>
    <div class="block_5 flex-col">
      <div class="group_2 flex-col">
        <div class="section_1 flex-row">
          <div class="image-wrapper_1 flex-col">
            <img
              class="image_3"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng3d44b0a83145593affc9e9e57a678d3cb86f2ebd27673abed9e64dc8f26b83ca.png"
            />
          </div>
          <div class="image-wrapper_2 flex-col">
            <img
              class="image_4"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPnga15f6fb86b5941b89fde576ea97a64a0b6ec01fe49eb9eb6d50c552854800404.png"
            />
          </div>
          <div class="image-wrapper_3 flex-col">
            <img
              class="image_5"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPngeca35eecdb147210a54d98a7847d69d3bc8b5291bca42985267a52ca1ac8d9a3.png"
            />
          </div>
        </div>
        <div class="section_2 flex-row">
          <div class="image-wrapper_4 flex-col">
            <img
              class="image_6"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPnge0069fd6417050fddf217e7e36ce027b9ec4ca062864b4195d333a3e726c3a93.png"
            />
          </div>
          <div class="image-wrapper_5 flex-col">
            <img
              class="image_7"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPngc85d8e32530ff3cd98ab31e42818c4a52f0082b5288f53b0338c7662e4aea306.png"
            />
          </div>
          <div class="image-wrapper_6 flex-col">
            <img
              class="image_8"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng82e4bbae3bc8f75205db9f05a4b3a7979811b7c4d88c5eadcfeca82fd0ea6c6f.png"
            />
          </div>
        </div>
      </div>
      <div class="group_3 flex-col">
        <div class="block_6 flex-row">
          <div class="image-wrapper_7 flex-col">
            <img
              class="image_9"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng1388a6ad401e56a8892faf19349d639dfc130ffa594a39d516538bdf38b2da80.png"
            />
          </div>
          <div class="image-wrapper_8 flex-col">
            <img
              class="image_10"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPngbb9b1b5b909e33d45d91a10213a97e4ee64bf99288f3c0e135b7cf93ae171748.png"
            />
          </div>
          <div class="image-wrapper_9 flex-col">
            <img
              class="image_11"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPngc9be23a64f538a5f437c33110300a2a48a5006714cc5a34ddd3bb74081cd3b74.png"
            />
          </div>
        </div>
        <div class="block_7 flex-row">
          <div class="image-wrapper_10 flex-col">
            <img
              class="image_12"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng59d3405d541156cc45c9bb79be3b9b757c4c8bb544bac8aadc6e4f3a37d1810d.png"
            />
          </div>
          <div class="image-wrapper_11 flex-col">
            <img
              class="image_13"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng9d772d71b64a792c78d169d38b3f76d17ed2849031cbff775c7e71fe8d6e87f7.png"
            />
          </div>
          <div class="image-wrapper_12 flex-col">
            <img
              class="image_14"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng3671963937ffd1b372d4c62cb5be1b7fe9b81ca7abaef4471a12bd51cf62b56e.png"
            />
          </div>
        </div>
      </div>
      <div class="group_4 flex-col">
        <div class="block_8 flex-row">
          <div class="image-wrapper_13 flex-col">
            <img
              class="image_15"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPngd073b8c2e98c998a14c6556b8d9450e1d8998d19c8c16a1caca393815f348f8d.png"
            />
          </div>
          <div class="image-wrapper_14 flex-col">
            <img
              class="image_16"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng431f51627a75304e4f7bdc740daea2ebf78fb17e5f0762409853e83c5cf838dc.png"
            />
          </div>
          <div class="image-wrapper_15 flex-col">
            <img
              class="image_17"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng4f6da277ee626f2cd7f35cc7054a404f1d8eb194640fefdc5bf2f6b066de4042.png"
            />
          </div>
        </div>
        <div class="block_9 flex-row">
          <div class="image-wrapper_16 flex-col">
            <img
              class="image_18"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng10643c768037a78215c4e0083b4f767d707bac39c0e133daf733d8823cc85bce.png"
            />
          </div>
          <div class="image-wrapper_17 flex-col">
            <img
              class="image_19"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPngf0cd179c3ad6c868b4a6030492dfe52ee36bf542d3c78403aecb7c8d94e90616.png"
            />
          </div>
          <div class="image-wrapper_18 flex-col">
            <img
              class="image_20"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng48fbec55ef659f3c59d4a704a42dba0bc376c1190392bf089569e522fdcd0515.png"
            />
          </div>
        </div>
      </div>
      <img
        class="image_21"
        referrerpolicy="no-referrer"
        src="./assets/img/SketchPngc06a197ef7a9500c790ed5b32d00a4485bc2a7b49f9fb4542b876857ebba4c71.png"
      />
      <img
        class="image_22"
        referrerpolicy="no-referrer"
        src="./assets/img/SketchPng5e79a86c266fb8f054fd2d8ce46aff6d97aacdd051e5985afa1132556c403f42.png"
      />
      <div class="group_5 flex-row">
        <div class="image-wrapper_19 flex-col">
          <img
            class="image_23"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPngddefe8e6d3ac9485bb71da77530b8ebd822ead9b438437c5c146a90e5edfb765.png"
          />
        </div>
        <div class="image-wrapper_20 flex-col">
          <img
            class="image_24"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng4a5bf4722a3b7db29c7d33d05f3bdc62376bf4df5d969d83e736acc28b86ef90.png"
          />
        </div>
      </div>
    </div>
    <div class="block_10 flex-col">
      <div class="text-wrapper_1 flex-row">
        <span class="text_7">公司信息</span>
        <span class="text_8">二维码</span>
        <span class="text_9">商务合作</span>
      </div>
      <div class="image-wrapper_21 flex-row justify-between">
        <img
          class="image_25"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng1c0a871b3fb97b29a5d07e5b71ab2c9223c1b2d4b7269d3443356771d6bdf9aa.png"
        />
        <img
          class="image_26"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng1c0a871b3fb97b29a5d07e5b71ab2c9223c1b2d4b7269d3443356771d6bdf9aa.png"
        />
        <img
          class="image_27"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng1c0a871b3fb97b29a5d07e5b71ab2c9223c1b2d4b7269d3443356771d6bdf9aa.png"
        />
      </div>
      <div class="block_11 flex-row">
        <span class="paragraph_1">
          江苏慧安智远智能医疗科技有限公司
          <br />
          <br />
          地址：无锡市惠山区惠山大道1719-5号二层B区&nbsp;
          <br />
          电话：0510-83582015
          <br />
          邮箱：huianzhiyuan&#64;qq.com
          <br />
          官网：www.hilears.com&nbsp;
          <br />
        </span>
        <div class="image-text_1 flex-col justify-between">
          <div class="image-wrapper_22 flex-col">
            <img
              class="image_28"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng6d89f0dbceb8cf2835772a0f780d8d18a85d8ad63f161fa6700239ef2ee1b0b1.png"
            />
          </div>
          <span class="text-group_1">
            关注公众号：HILEARS和尔思
            <br />
          </span>
        </div>
        <span class="text_10">卢先生&nbsp;&nbsp;0510-83582015</span>
      </div>
      <div class="text-wrapper_2 flex-row">
        <span class="text_11">
          Copyright&nbsp;©&nbsp;&nbsp;2025&nbsp;-&nbsp;forever&nbsp;&nbsp;江苏慧安智远智能医疗科技有限公司所有
          <a onclick="window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32020602001022')">苏公网安备
            32020602001022号&nbsp;&nbsp;</a>
          <a onclick="window.open('https://beian.miit.gov.cn')">苏ICP备20031743号-1</a>

        </span>
      </div>
    </div>
    <div class="block_12 flex-col">
      <span class="text_12">公司简介</span>
      <span class="paragraph_2">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;江苏慧安智远智能医疗科技有限公司（以下简称“公司”）于2019年11月注册成立，注册资金6000万元，租用无锡惠山新城生命科技产业发展有限公司厂房面积1058平方米，主要从事医疗仪器设备及器械、电子设备、通讯产品、电子智能终端的研发、生产、销售；机器人、智能家居产品的加工、销售。
        <br />
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;公司集产、学、研为一体，以国家“互联网+物联网+医疗”发展战略为指引，致力于医疗物联网领域的研究与开发。公司与知名大学和医院联合建立了战略合作，自主研发出和尔思麻精药品及高值耗材智能管理云平台和终端，并获得多项专利，现已形成麻精药品智能管理、麻精药品移动管理和高值耗材智能管理等系列解决方案和产品。公司结合中国医院实际业务流程、药品供应管理流程，将医院药品全流程精细化管理需求与大数据管理、物联网、自动化等技术理念进行整合，助力医院全方位信息化建设和精细化管理。
        <br />
        除以上项目，公司还对过氧化氢雾化消毒机、医院物流机器人、医用电动转运车等项目进行研发。过氧化氢雾化消毒机主要用于各科室终末消毒，布朗运动将干雾扩散到各个角落实现杀菌消毒作用。医院物流机器人系统主要用于手术室与药房之间的物资配送，以卓越的技术、品质及性能，实现麻醉科室全覆盖。医院物流机器人无需搭建复杂的传输轨道，完美超越传统物流配送模式，构建全方位、立体化的麻醉科内物流自动配送系统，实现物流立体化、高效化、无纸化管理，为现代医院提供数字化、信息化物流管理解决方案。展望未来，公司将不断加大对临床需求与科技前沿技术整合，形成区域信息平台与数字化医院相结合，覆盖城市主流医疗信息化发展的完整体系，为智慧城市、智慧医疗提供完美解决方案。
        <br />
        <br />
      </span>
      <img
        class="image_29"
        referrerpolicy="no-referrer"
        src="./assets/img/SketchPngfa4e922d0e743f5f8661ce0ee72627bb9cf59116fe2db4c693cef816aba34a84.png"
      />
      <span class="text_13">专利软著</span>
      <div class="block_13 flex-col">
        <div class="section_3 flex-row">
          <div class="image-wrapper_23 flex-col">
            <img
              class="image_30"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPngc9c141eaeaaf2be8dacbfddda139af6a069217d1a418dac9b8ba9f07fb13dbf8.png"
            />
          </div>
          <div class="image-wrapper_24 flex-col">
            <img
              class="image_31"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng4bbc11381266b494fcc5486628bab4c8ed269c83d7c6bb2cebd8e56bec596318.png"
            />
          </div>
          <div class="image-wrapper_25 flex-col">
            <img
              class="image_32"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng956fe79b0af59710e855d50668b6de8cef67e0bb03c3f32d9a37b96af0245b9f.png"
            />
          </div>
        </div>
        <div class="section_4 flex-row">
          <div class="image-wrapper_26 flex-col">
            <img
              class="image_33"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng519ca40167a9e079b1f53f3e5549e2ad140d9fb70d4f543f896df88e561ec255.png"
            />
          </div>
          <div class="image-wrapper_27 flex-col">
            <img
              class="image_34"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng530e7af984bf512769c0b381b42bd01ca7b01a6e9dc40ec77907938c5d3281d8.png"
            />
          </div>
          <div class="image-wrapper_28 flex-col">
            <img
              class="image_35"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng1c913217c56f7ec3dd0fa1c4585999725eb6c225f6fed52d5ede028cdde1afd3.png"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
       // 新增下拉菜单控制变量
      showDropdown: false,
      constants: {}
    };
  },
  methods: {
      // 新增下拉菜单点击处理方法
    handleCaseClick(type) {
      // 根据不同案例类型跳转到不同页面
      this.$router.push(`/${type}`);
      // 关闭下拉菜单
      this.showDropdown = false;
    },
        PageIndex() {
      this.$router.push('/PageIndex')
    },
     sdycxq() {
      this.$router.push('/three_narcotic_drug_vehicle')
    },
    guanyuhuian() {
      this.$router.push('/guanyuhuian')
    },
    case_presentation() {
      this.$router.push('/case_presentation')
    },
    news_information() {
      this.$router.push('/news_information')
    },
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style>
/* 修改下拉菜单样式 */
.dropdown-container {
  position: relative;
  display: inline-flex;
  /* 使用inline-flex保持与其他元素对齐 */
  align-items: center;
  /* 确保文本垂直居中 */
  height: 50%;
  /* 占满父容器高度 */
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  /* 从容器底部开始显示 */
  left: 0;
  background-color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  min-width: 160px;
  z-index: 1000;
  margin-top: 5px;
  /* 与主菜单保持一点距离 */
  padding: 8px 0;
  animation: fadeIn 0.2s ease-in-out;
}

/* 调整菜单项样式 */
.dropdown-item {
  padding: 10px 16px;
  color: #1d1f24;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

/* 修复父容器对齐 */
.box_1 {
  align-items: center;
  /* 确保所有子元素垂直居中 */
  display: flex;
}

/* 保持其他样式不变 */
.text_4 {
  /* 确保文本本身垂直居中 */
  display: inline-flex;
  align-items: center;
  height: 100%;
}

/* 动画效果 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
